// 根据文件名后缀区分 文件类型
/*
 * @param: fileName - 文件名称
 * @param: 数据返回 1) 无后缀匹配 - false
 * @param: 数据返回 2) 匹配图片 - image
 * @param: 数据返回 3) 匹配 txt - txt
 * @param: 数据返回 4) 匹配 excel - excel
 * @param: 数据返回 5) 匹配 word - word
 * @param: 数据返回 6) 匹配 pdf - pdf
 * @param: 数据返回 7) 匹配 ppt - ppt
 * @param: 数据返回 8) 匹配 视频 - video
 * @param: 数据返回 9) 匹配 音频 - radio
 * @param: 数据返回 10) 其他匹配项 - other
 */
function matchType(fileName) {
    console.log('fileName = ', fileName);
    // 后缀获取
    let suffix = '';
    // 获取类型结果
    let result = '';
    // 不同类型对应的icon
    let icon = 'iconwenjian1';
    try {
        const flieArr = fileName.split('.');
        suffix = flieArr[flieArr.length - 1];
    } catch (err) {
        suffix = '';
    }
    // fileName无后缀返回 false
    if (!suffix) {
        result = false;
        return { type: result, icon };
    }
    // 图片格式
    const imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
    // 进行图片匹配
    result = imglist.some(function (item) {
        return item === suffix;
    });
    if (result) {
        result = 'image';
        icon = 'icontupian1';
        return { type: result, icon };
    }
    // 匹配txt
    const txtlist = ['txt'];
    result = txtlist.some(function (item) {
        return item === suffix;
    });
    if (result) {
        result = 'txt';
        icon = 'icontxt-full';
        return { type: result, icon };
    }
    // 匹配 excel
    const excelist = ['xls', 'xlsx'];
    result = excelist.some(function (item) {
        return item === suffix;
    });
    if (result) {
        result = 'excel';
        icon = 'iconExcel2';
        return { type: result, icon };
    }
    // 匹配 word
    const wordlist = ['doc', 'docx'];
    result = wordlist.some(function (item) {
        return item === suffix;
    });
    if (result) {
        result = 'word';
        icon = 'iconDOC';
        return { type: result, icon };
    }
    // 匹配 pdf
    const pdflist = ['pdf'];
    result = pdflist.some(function (item) {
        return item === suffix;
    });
    if (result) {
        result = 'pdf';
        icon = 'iconpdf2';
        return { type: result, icon };
    }
    // 匹配 ppt
    const pptlist = ['ppt'];
    result = pptlist.some(function (item) {
        return item === suffix;
    });
    if (result) {
        result = 'ppt';
        icon = 'iconppt';
        return { type: result, icon };
    }
    // 匹配 视频
    const videolist = ['mp4', 'm2v', 'mkv'];
    result = videolist.some(function (item) {
        return item === suffix;
    });
    if (result) {
        result = 'video';
        icon = 'iconvideofill';
        return { type: result, icon };
    }
    // 匹配 音频
    const radiolist = ['mp3', 'wav', 'wmv'];
    result = radiolist.some(function (item) {
        return item === suffix;
    });
    if (result) {
        result = 'radio';
        icon = 'iconradiobox';
        return { type: result, icon };
    }

    // 匹配 压缩包
    const packagelist = ['zip', 'rar', 'tar'];
    result = packagelist.some(function (item) {
        return item === suffix;
    });
    if (result) {
        result = 'zip';
        icon = 'iconyasuobao';
        return { type: result, icon };
    }

    // 匹配 CSV
    const CSVlist = ['csv'];
    result = CSVlist.some(function (item) {
        return item === suffix;
    });
    if (result) {
        result = 'csv';
        icon = 'iconCSV';
        return { type: result, icon };
    }

    // 匹配 SQL
    const SQLlist = ['db'];
    result = SQLlist.some(function (item) {
        return item === suffix;
    });
    if (result) {
        result = 'sql';
        return { type: result, icon };
    }

    // 其他 文件类型
    result = 'other';
    return { type: result, icon };
}

// 关键
export {
    matchType,
};
